/* eslint-disable react-hooks/exhaustive-deps */
import { Button, IconButton, Modal } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Collapse, List, Typography } from "@mui/material";
import SubItemCloseIcon from "assets/icons/SubItemCloseIcon";
import SubItemOpenIcon from "assets/icons/SubItemOpenIcon";
import { StyledListItemButton, StyledListItemIcon, StyledListItemText } from "components/Reports/components";
import { IOSSwitch } from "components/Input/switch";
import CustomizeIcon from "assets/icons/CustomizeIcon";
import Portal from "components/Portal";
import Tabs from "components/Tabs";
import ModalBox from "components/Shared/Modals/ModalBox";
import TableFilterIcon from "assets/images/TableFilterIcon.svg";

export interface PreferencesProps {
  data: Preferences;
}
export default function Preferences({ data }: PreferencesProps) {
  const { onChange, tabs } = data;
  const btnRef = useRef<any>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [items, setItems] = useState<any[]>();
  const [activeTab, setActiveTab] = useState(1);
  const open = Boolean(anchorEl);

  useEffect(() => setItems(data.items), [data.items]);

  function getFilterItems(i: Preferences["items"]) {
    if (!i) return [];
    let items = i;
    if (tabs) items = items.filter((x) => x.tabKey === activeTab);
    items = items.map((x) => ({ ...x, children: [] as any[] }));
    return items.flatMap((x) => {
      if (!x.id) return [];
      if (x.parentId) {
        const parent = items.find((y) => y.id === x.parentId);
        if (parent) parent.children.push(x);
      }
      return x;
    });
  }

  function handleChange(item: any) {
    let newItems = [...(items || [])];
    const index = newItems.findIndex((x) => x.id === item.id && (tabs ? x.tabKey === activeTab : true));
    if (tabs) {
      const same = newItems.find((x) => x.id === item.id && x.tabKey !== activeTab);
      if (same && same.active) {
        return;
      }
    }
    if (index >= 0) newItems[index] = item;
    setItems(newItems);
  }

  function handleTabChange(val?: number) {
    if (val === undefined) return;
    const key = val + 1;
    setActiveTab(key);
  }

  const filterItems = getFilterItems(items).find((x) => !x.parentId);

  return (
    <>
      <IconButton style={{ padding: 0 }} ref={btnRef} onClick={(e) => setAnchorEl(e.currentTarget)}>
        <img src={TableFilterIcon} alt="" />
      </IconButton>
      <Portal>
        <Modal disableScrollLock open={open}>
          <ModalBox
            title={"ستون های قابل نمایش"}
            onClose={() => setAnchorEl(null)}
            style={{
              container: { width: "50%" },
              body: { borderRadius: 0, overflow: "auto" },
            }}
            footer={
              <>
                <div
                  style={{
                    padding: "6px 24px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={() => onChange(items || [])}
                    style={{ minWidth: "150px" }}
                  >
                    اعمال
                  </Button>
                </div>
              </>
            }
          >
            {tabs && <Tabs activeTab={activeTab - 1} tabs={tabs} onChange={handleTabChange} />}
            <div style={{ height: 300 }}>
              <div>{filterItems && <FilterItems data={filterItems} onChange={handleChange} />}</div>
            </div>
          </ModalBox>
        </Modal>
      </Portal>
    </>
  );
}

interface FilterItemsProps {
  data: any;
  childrenKey?: string;
  onChange?: (item: any) => void;
}

function FilterItems({ data, onChange, childrenKey }: FilterItemsProps) {
  const [open, setOpen] = useState<boolean>(!data.parentId);
  const [active, setActive] = useState<boolean>(data.active);
  const key = childrenKey || "children";
  const hasChild = data[key] && data[key].length > 0;

  function handleClick() {
    if (hasChild) setOpen((open) => !open);
  }

  useEffect(() => {
    onChange && onChange({ ...data, active });
  }, [active]);

  return (
    <>
      <StyledListItemButton disableRipple active={open} onClick={handleClick}>
        {hasChild && (
          <StyledListItemIcon>{open ? <SubItemCloseIcon /> : <SubItemOpenIcon />}</StyledListItemIcon>
        )}
        {!hasChild && <CustomizeIcon />}
        <StyledListItemText>
          <Typography variant="body2">{data.title}</Typography>
        </StyledListItemText>
        {!hasChild && <IOSSwitch onChange={() => setActive((active) => !active)} defaultChecked={active} />}
      </StyledListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {data[key] &&
            data[key].map((item: any, index: any) => {
              return (
                <div key={index} style={{ paddingRight: "16px" }}>
                  <FilterItems data={item} onChange={onChange} />
                </div>
              );
            })}
        </List>
      </Collapse>
    </>
  );
}
